import AutomasPeritajeEntity from "../../../../domain/entities/AutomasPeritajeEntity";

/**
 * Respuesta real de `GET /get-car-automas/<placa>/` tal como la entrega el backend hoy.
 * Sirve para ver el certificado con exactamente los campos que existen.
 */
export const automasPeritajeCarMock: AutomasPeritajeEntity = {
    car_class: "AUTOMOVIL",
    brand: "MAZDA",
    type: "CX-30 GRAND TOURING",
    body_type: "CAMIONETA",
    model: "2022",
    nationality: "JAPON",
    gearbox_type: "AUTOMATICA",
    engine_capacity: "2.00",
    insurance_company: "SURA",
    intermediary: "WCAR",
    client: "JUAN PEREZ GOMEZ",
    fuel_type: "GASOLINA",
    paint_type: "BICAPA",
    service_type: "PARTICULAR",
    mileage: 45300,
    color: "ROJO",
    chassis_number: "3MVDMBDM1NM123456",
    serial_number: "3MVDMBDM1NM123456",
    engine: "PEY712345",
    branch: "BOGOTA NORTE",
    key: "2",
    identification: "1020304050",
    insurable: true,
    inspection_number: "INS-2026-000123",
    date: "2026-08-05",
    inspection_center: "CDA AUTOMAS CALLE 80",
    plate: "ABC123",
    market_value: "89000000.00",
    author_value: "85000000.00",
    accessory_value: "3500000.00",
    fasecolda_code: "05801104",
    fasecolda_value: "87500000.00",
    accessories: [
        { id: 41, description: "RINES DE LUJO", brand: "MAZDA", quantity: 4, value: "2000000.00", car_details: 12 },
        { id: 42, description: "EXPLORADORAS", brand: "GENERICO", quantity: 2, value: "1500000.00", car_details: 12 },
    ],
    images: [
        {
            id: 87,
            url: "https://storage.googleapis.com/wcar-images/automas/ABC123/image_0.jpg",
            car_details: 12,
        },
        {
            id: 88,
            url: "https://storage.googleapis.com/wcar-images/automas/ABC123/image_1.jpg",
            car_details: 12,
        },
    ],
    photos: [
        {
            id: 55,
            url: "https://storage.googleapis.com/wcar-images/automas/ABC123/photo_0.jpg",
            car_details: 12,
        },
    ],
    visual_inspection: [
        { item: "LATONERIA", estado: "BUENO", observacion: "Rayón leve en puerta trasera derecha" },
        { item: "PINTURA", estado: "REGULAR", observacion: "Repintado en capó" },
        { item: "LLANTAS", estado: "BUENO", observacion: "70% de labrado" },
    ],
    observations: [
        { tipo: "GENERAL", descripcion: "Vehículo en buen estado general, sin reporte de siniestros." },
        { tipo: "MECANICA", descripcion: "Requiere cambio de pastillas delanteras." },
    ],
    acta: "000456",
    service_number: "P008207065932XXX",
    fasecolda_claims: false,
    requested_service: "PERITAJE PLATA LIVIANO",
    result: "VEHICULO EN ESTANDAR",
    requested_by: "JHON DAVIS BERNAL FORERO",
    turn: 1,
    brake_efficiency: { front: 67, rear: 77, total: 72 },
    parking_brake: 37,
    suspension: { front: 67, rear: 77 },
    alignment: { front: 67, rear: 77 },
    tire_life: { front: 20, rear: 20 },
};

/**
 * Mismo endpoint pero con los campos opcionales del formato impreso ya poblados
 * (turno, resultado, grupos de inspección, frenado, llantas y luces). Es el escenario
 * que reproduce el diseño de referencia "Certificado Peritaje Motos" completo.
 */
export const automasPeritajeMotoMock: AutomasPeritajeEntity = {
    car_class: "MOTOCICLETA",
    brand: "BAJAJ",
    type: "DOMINAR D MT 250CC",
    body_type: "OTROS",
    model: "2024",
    nationality: "SIN IDENTIFICAR",
    gearbox_type: "MECANICA",
    engine_capacity: "249",
    insurance_company: "WCAR SAS - CREDITO",
    intermediary: "",
    client: "W CAR SAS",
    fuel_type: "GASOLINA",
    paint_type: "PENDIENTE",
    service_type: "PARTICULAR",
    mileage: 8878,
    color: "GRIS PIEDRA",
    chassis_number: "MD2B58BX2RCA12345",
    serial_number: "MD2B58BX2RCA12345",
    engine: "JFXCNQ50619",
    branch: "WCAR SAS - CREDITO",
    key: "1",
    identification: "9001234567",
    insurable: false,
    inspection_number: "5162956",
    date: "2026-08-05",
    inspection_center: "AUTOMAS MORATO",
    plate: "XYZ98F",
    market_value: "0.00",
    author_value: "12800000.00",
    accessory_value: "0.00",
    fasecolda_code: "00317092",
    fasecolda_value: "12800000.00",
    turn: 1,
    requested_by: "",
    requested_service: "PERITAJE PLATA MOTOCICLETAS SUPERBIKE",
    result: "VEHICULO EN ESTANDAR",
    accessories: [],
    images: [],
    photos: [],
    visual_inspection: [],
    observations: [
        {
            tipo: "",
            descripcion:
                "NO REPORTA SINIESTROS ANTE FASECOLDA PUBLICO. PRESENTA COPIA DE LICENCIA DE TRANSITO IMPRESA EN FORMATO DIGITAL. ESTUDIO TÉCNICO REALIZADO CON BASE EN CONSULTA PUBLICA RUNT A LA FECHA DE INSPECCION. RAYONES EN TAPAS-CARENADO. PERDIDA DE MATERIAL EN PROTECTORES HAND SAVER Y DEFENSAS. REVISAR Y AJUSTAR SISTEMA DE EMBRAGUE. SE RECOMIENDA REVISAR SISTEMA DE SUSPENSIÓN DELANTERA. SISTEMAS DE SEGURIDAD ORIGINALES HASTA LA FECHA DE INSPECCION.",
        },
    ],
    inspection_groups: [
        {
            title: "ESTRUCTURA - CHASIS",
            percentage: 97.5,
            items: [
                { description: "DEFENSA / SLIDER", state: "RAYON" },
                { description: "SOPORTE CENTRAL", state: "NO APLICA" },
                { description: "SOPORTE LATERAL DE ESTACIONAMIENTO", state: "REGULAR" },
            ],
        },
        {
            title: "CARENAJE Y COMPLEMENTOS",
            percentage: 100,
            items: [
                { code: "793", description: "AGARRADERAS DE COPILOTO", state: "RAYON" },
                { code: "795", description: "CUPULA", state: "RAYADO" },
                { code: "804", description: "QUILLA / PROTECTOR DE MOTOR", state: "RAYON" },
                { code: "811", description: "SOPORTES POSAPIES", state: "RAYON" },
                { code: "815", description: "TAPAS LATERALES TRASERAS", state: "RAYON" },
            ],
        },
        {
            title: "FUGA DE FLUIDOS",
            percentage: 100,
            items: [{ code: "782", description: "ACEITE CAJA", state: "NO APLICA" }],
        },
        {
            title: "PINTURA",
            percentage: 92,
            items: [{ code: "34", description: "PERDIDA DE BRILLO", state: "DE 1 A 4 PIEZAS" }],
        },
    ],
    acta: "000457",
    service_number: "P008207065933XXX",
    fasecolda_claims: false,
    brake_efficiency: { front: 78, rear: 71, total: 75 },
    parking_brake: 74,
    suspension: { front: 82, rear: 79 },
    alignment: { front: 88, rear: 91 },
    tire_life: { front: 60, rear: 60 },
    lights: { inclination: 70, intensity: 0 },
};

export const automasPeritajeMock = automasPeritajeCarMock;
